module.exports = __webpack_public_path__ + "d5f7de8b7b2ed417f10fe909cf051021.png";